import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker'
import { Component, Input } from '@angular/core'
import { Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { MediaFile, MediaFileBundle, MediaRootDetail } from 'elements-sdk'

import { NotifyService } from 'common/util/module'
import { SequenceTools } from 'media.editor/sequenceTools'
import { Sequence, Track, TrackItem } from 'media.editor/model'
import { Framerate, Time } from '../time'
import { APIService } from 'api/module'
import { SubclipsClipboardService } from 'media/services/subclipsClipboard.service'
import { MediaProjectContainer } from 'media.editor/mediaProjectContainer'

@Component({
  templateUrl: './createEditorProjectModal.component.pug',
})
export class CreateEditorProjectModalComponent {
  @Input() file: MediaFile
  @Input() root: MediaRootDetail
  @Input() bundles: MediaFileBundle[]
  includeSubclips = false
  name = ''

  pluralize = {
    selectedSubclips: _(
      `Include {count, plural,
          one{1 selected subclip}
          other{{count} selected subclips}}`),
  }

  constructor (
    private modalInstance: NgbActiveModal,
    private router: Router,
    private translate: TranslateService,
    private notify: NotifyService,
    private api: APIService,
    public subclipsClipboard: SubclipsClipboardService,
  ) { }

  create = async () => {
    let name = this.name

    if (!name) {
      return
    }
    if (!name.endsWith('.xml')) {
      name += '.xml'
    }
    if (this.bundles.some(x => x.name === name)) {
      this.notify.error(this.translate.instant('This name is already used'))
      return
    }

    const project = new MediaProjectContainer(this.api, this.root, {
      children: [
        {
          name: 'Sources',
          children: [],
          type: 'bin',
          id: '1',
        },
        {
          name: 'Subclips',
          children: [],
          type: 'bin',
          id: '2',
        },
      ],
      name,
      elements: true,
      format: 'fcpxml',
      path_format: 'mac',
    })

    if (this.includeSubclips) {
      const track = new Track()
      const seq = new Sequence()

      Object.assign(seq, {
        id: project.newID(),
        name: 'Sequence',
        timebase: new Framerate(50),
        tracks: [track],
      })
      project.children.push(seq)

      let start = Time.zero
      const tools = new SequenceTools(seq, project)
      for (const subclip of this.subclipsClipboard.items) {
        const clip = await project.addSubclip(subclip)

        const item = new TrackItem()
        Object.assign(item, {
          id: project.newID(),
          start,
          end: null,
          duration: clip.duration ?? 60,
          tIn: clip.tIn,
          tOut: clip.tOut ?? 60,
          master_id: clip.master_id || clip.id,
          is_master: false,
          is_subclip: false,
          timebase: clip.timebase,
        })

        tools.overwriteInsert(item, track, start)
        start = item.end
      }
    }

    try {
      const response = await this.api.mediaLibrary.createEditorProject({
        editorProjectUpdate: {
          project: project.serialize(),
          format: 'fcpxml',
          parent: this.file.id,
        },
      })
      this.router.navigateByUrl(`/media/editor/${this.root.id}/${response.file}`)
      this.modalInstance.close(this.root)
    } catch (e) {
      this.notify.error(this.translate.instant('Failed to create a project'), e.data.message)
    }
  }

  cancel () {
    this.modalInstance.close(this.root)
  }
}
